// import { AdminRoot } from "@/admin/AdminRoot.tsx";
import AdminRoot from "@/admin/AdminRoot.tsx";
import { isLoggedInAtom } from "@/modules/api/apikey.store.ts";
import LoginsRoot from "@/modules/login/LoginsRoot.tsx";
import { AuthenticatedRootProviders } from "@/modules/main/MainRoot.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";
import { useAtomValue } from "jotai/react";

export const Route = createLazyFileRoute("/admin")({
    component: AdminRoutes,
});

function AdminRoutes() {
    const loggedIn = useAtomValue(isLoggedInAtom);
    if (!loggedIn) {
        return <LoginsRoot />;
    }

    return (
        <AuthenticatedRootProviders>
            <AdminRoot />
        </AuthenticatedRootProviders>
    );
}
